import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { gbp, num, makeFilters, toParams } from "@/lib/format";
import { FilterBar } from "@/components/FilterBar";
import { PageHeader } from "@/components/PageHeader";
import { OrdersTable } from "@/components/OrdersTable";
import { OrderDetailSheet } from "@/components/OrderDetailSheet";
import { Button } from "@/components/ui/button";

const LIMIT = 25;

export default function Orders() {
  const [filters, setFilters] = useState(makeFilters("90d"));
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0, total_value: 0 });
  const [open, setOpen] = useState(null);
  const load = () => api.get("/orders", { params: { ...toParams(filters), page, limit: LIMIT } }).then((r) => setData(r.data));
  useEffect(() => { setPage(1); }, [filters]);
  useEffect(() => { const t = setTimeout(load, 200); return () => clearTimeout(t); }, [filters, page]); // eslint-disable-line
  const pages = Math.max(1, Math.ceil(data.total / LIMIT));
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Orders" title="Order history">
        <div className="rounded-lg border bg-white px-4 py-2 text-right">
          <div className="label-xs">{num(data.total)} orders</div>
          <div className="font-display text-lg font-bold" data-testid="orders-total-value">{gbp(data.total_value)}</div>
        </div>
      </PageHeader>
      <FilterBar filters={filters} setFilters={setFilters} defaultPreset="90d" show={{ status: true, category: true, source: true, search: true }} />
      <OrdersTable items={data.items} onOpen={setOpen} />
      <div className="flex items-center justify-between text-sm text-slate-500">
        <span data-testid="orders-page-info">Page {page} of {pages}</span>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="orders-prev-page"><ChevronLeft className="h-4 w-4" /></Button>
          <Button variant="outline" size="sm" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid="orders-next-page"><ChevronRight className="h-4 w-4" /></Button>
        </div>
      </div>
      <OrderDetailSheet orderId={open} onClose={() => setOpen(null)} onChanged={load} />
    </div>
  );
}
